import {useCallback, useMemo, useState} from "react";
import {CreditCalculatorState, RideId, RideSelection} from "pages/Front/Booking/Credits/CreditCalculator/types";
import {emptySelection, exceedsLargestPack, findRecommendation, totalCreditsNeeded} from "pages/Front/Booking/Credits/CreditCalculator/utils";

/**
 * State and derived values for the interactive credit calculator.
 * Selection is ephemeral by design: nothing here persists into a booking.
 */
export function useCreditCalculator(): CreditCalculatorState {
    const [selection, setSelection] = useState<RideSelection>(emptySelection());

    const increment = useCallback((id: RideId): void => {
        setSelection(prev => ({...prev, [id]: prev[id] + 1}));
    }, []);

    const decrement = useCallback((id: RideId): void => {
        setSelection(prev => ({...prev, [id]: Math.max(0, prev[id] - 1)}));
    }, []);

    const creditsNeeded = useMemo(() => totalCreditsNeeded(selection), [selection]);

    const recommendation = useMemo(() => findRecommendation(creditsNeeded), [creditsNeeded]);

    const needsCombination = useMemo(() => exceedsLargestPack(creditsNeeded), [creditsNeeded]);

    return {selection, creditsNeeded, recommendation, needsCombination, increment, decrement};
}
